import xman from '@/common/xman';
import { addFavorite, checkFavorite, removeFavorite } from '@/utils/favorite';
import { checkIsLogged } from '@/utils/getCookieInfo';
import React, { useState, useEffect } from 'react';
import doLog from '@/common/log';

interface FavoriteResult {
  isFavorite?: boolean;
  success?: boolean;
  message?: string;
}

export function useFavorite(productId: number) {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    //如果已登陆
    if (checkIsLogged()) {
      //查询商品是否收藏
      checkFavorite(productId).then((result: FavoriteResult) => {
        if (result && result.isFavorite) {
          setIsFavorite(true);
        }
      });
    } else {
      setIsFavorite(false);
    }
  }, [productId]);

  //商品收藏逻辑
  const handleFavorite = () => {
    // 判断是否登陆
    if (checkIsLogged()) {
      doLog('/sc.details.addFav');
      //如果已经收藏，取消收藏
      if (isFavorite) {
        removeFavorite(productId).then((result: FavoriteResult) => {
          if (result && result.success) {
            setIsFavorite(false);
          }
        });
      } else {
        addFavorite(productId).then((result: FavoriteResult) => {
          if (result && result.success) {
            setIsFavorite(true);
          }
        });
      }
    } else {
      //没登陆 出登陆弹窗
      xman(() => {
        //查询商品是否收藏
        checkFavorite(productId).then((result: FavoriteResult) => {
          if (result && result.isFavorite) {
            setIsFavorite(true);
          }
        });
      });
    }
  };

  return {
    isFavorite,
    handleFavorite,
  };
}
